import { Component, OnInit } from '@angular/core';
import { Offerte } from '../model/offerte';
import { OfferteServiceService } from '../service/offerte-service.service';
import { ActivatedRoute } from '@angular/router';
import { NgxCarousel } from 'ngx-carousel';
 

@Component({
  selector: 'app-offerta',
  templateUrl: './offerta.component.html',
  styleUrls: ['./offerta.component.scss']
})
export class OffertaComponent implements OnInit {
  id: number;
  private sub: any;
  public carousel: NgxCarousel;
  offerta: Offerte;
  lstOfferteAlternative: Array<Offerte>;
  constructor(private route: ActivatedRoute, private service : OfferteServiceService ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['idofferta']; // (+) converts string 'id' to a number
      //this.offerta = this.service.getOfferta(this.id);
      this.offerta = null;
      this.service.getOfferta(this.id).subscribe(data => {
          this.offerta = data;

          this.lstOfferteAlternative=null;
          this.service.getOfferteAlternativeOfferta(this.offerta.Id_Foritore, this.offerta.Id_comodity).subscribe(data => {
              this.lstOfferteAlternative = data;
          });
      });
      // In a real app: dispatch action to load the details here.
    });
    this.carousel = {
      grid: {xs: 1, sm: 3, md: 3, lg: 5, all: 0},
      slide: 1,
      speed: 400,
      interval: 5000,
      loop:true,
      animation: 'lazy',
      point: {
        visible: true
      },
      load: 1,
      touch: true,
      easing: 'ease'
    }
    //  service= new OfferteServiceService();
    //  this.offerta= service.getOfferta(this.id);
    //  this.lstOfferteAlternative= service.getOfferteAlternativeOfferta(this.offerta.Id_Foritore,this.offerta.Id_comodity);
  }

  // async ScrollTopAnimate() {
  //   //var t = document.getElementById("form");
  //   var y =  window.scrollY;
    

  //   for (let posy = y; posy > 0; posy = posy - 25) {
  //     window.scrollTo(0, posy);
  //     await this.delay(1);
  //     console.log(posy);
  //   }

  //   window.scrollTo(0, 0);
  // }
  // delay(ms: number) {
  //   return new Promise(resolve => setTimeout(resolve, ms));
  // }
  // public myfunc(event: Event) {
  //   // carouselLoad will trigger this funnction when your load value reaches
  //   // it is helps to load the data by parts to increase the performance of the app
  //   // must use feature to all carousel
  // }

}



// WEBPACK FOOTER //
// ./src/app/offerta/offerta.component.ts